var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFooter',[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"container",attrs:{"id":"footer"}},[_c('div',{staticClass:"row text-uppercase"},[_c('FooterLinks'),_c('FooterMarketing')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }